const features = [
  {
    title: '高清画质',
    desc: '支持1080P超清画质播放，细节分毫毕现，让每一帧画面都如临其境。',
    icon: 'ri-4k-line',
    color: 'primary',
  },
  {
    title: '流畅不缓冲',
    desc: '自研视频加速引擎，智能预加载技术，告别卡顿等待，高清影视在线观看不缓冲。',
    icon: 'ri-speed-up-line',
    color: 'accent',
  },
  {
    title: '海量片库',
    desc: '汇集全网电视剧全集与电影大全，每日更新最新剧集，片库持续扩充中。',
    icon: 'ri-database-2-line',
    color: 'primary',
  },
  {
    title: '智能推荐',
    desc: '基于观影偏好与热度趋势的推荐算法，精准匹配您可能喜爱的内容，快速找片不再难。',
    icon: 'ri-brain-line',
    color: 'accent',
  },
  {
    title: '多端同步',
    desc: '支持电脑、平板、手机多终端无缝切换，观影进度自动同步，随时随地继续追剧。',
    icon: 'ri-smartphone-line',
    color: 'primary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            特色优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            五大核心优势，打造极致的高清影视在线观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, idx) => {
            const isPrimary = feat.color === 'primary';
            const iconBg = isPrimary ? 'bg-primary-500/10' : 'bg-accent-500/10';
            const iconColor = isPrimary ? 'text-primary-400' : 'text-accent-400';
            return (
              <div
                key={idx}
                className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6 text-center hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full ${iconBg} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feat.icon} text-2xl md:text-3xl ${iconColor}`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}